import moment from 'moment';
import { transformIdOfList } from '@casanova/casanova-common/lib/utils/transformHelpers';
import _get from 'lodash/get';
import {
  YYYY_MM_DD,
  ISO_DATE_FORMAT,
  MX_DATE_FORMAT,
  FULL_DATE_FORMAT,
} from 'utils/constants';
import types from './action-types';
import { MASSIVE_CHANGE_TYPES } from '../../containers/Contracts/common/constants';

const initialState = {
  responseDialog: {
    open: false,
    success: false,
    errorCode: '',
    errorMessage: '',
  },
  list: {
    params: {
      page: 0,
      size: 10,
      enable: true,
      property: 'folio',
      direction: 'desc',
    },
    searchPattern: '',
    filters: {
      minStartDate: '',
      maxStartDate: '',
      minEndDate: '',
      maxEndDate: '',
      businessAreas: [],
    },
    totalPages: 1,
    totalElements: 10,
    results: [],
  },
  saveContract: {
    success: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  contractDetails: {
    success: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  contractVehicles: {
    params: {
      page: 0,
      size: 5,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      page: 0,
      list: [],
      loading: false,
      success: false,
      error: false,
    },
  },
  changeOfVehicle: {
    success: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  createLoan: {
    success: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  editCategorySubcategory: {
    success: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  vehicleChangeIncidents: {
    error: false,
    errorMessage: '',
    list: [],
  },
  vehicleChangePeriodicities: {
    error: false,
    errorMessage: '',
    list: [],
  },
  responseDialogUpdateContract: {
    open: false,
    success: false,
    errorCode: '',
    errorMessage: '',
    modalType: '',
  },
  managers: [],
  coordinators: [],
  adminFleets: [],
  loader: false,
  massiveChangeType: MASSIVE_CHANGE_TYPES.GENERAL,
  confirmationMessage: false,
  massiveRecords: {
    success_records: [],
    failed_records: [],
    process: false,
  },
  resultMessage: {
    success: false,
    message: '',
    errorCode: '',
    open: false,
    actionLabel: '',
    title: '',
  },
  vehiclesMassiveChangeRecords: {
    success_records: [],
    failed_records: [],
    process: false,
  },
};

export function contractsReducer(state = initialState, { payload, type }) {
  // console.log('type', type);
  // console.log('payload', payload);
  let errorCode = '';
  if (payload && payload.data) {
    errorCode = payload.data.errorCode;
  }
  switch (type) {
    case types.GET_MANAGERS_SUCCEED:
      return {
        ...state,
        managers: payload,
      };
    case types.GET_COORDINATORS_SUCCEED:
      return {
        ...state,
        coordinators: payload,
      };
    case types.GET_ADMIN_FLEETS_SUCCEED:
      return {
        ...state,
        adminFleets: payload,
      };
    case types.SET_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          params: {
            ...state.list.params,
            ...payload,
            page: 0,
          },
        },
      };
    case types.RESET_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          params: initialState.list.params,
        },
      };
    case types.SET_LIST_PAGE:
      return {
        ...state,
        list: {
          ...state.list,
          params: {
            ...state.list.params,
            page: payload,
          },
        },
      };
    case types.GET_LIST_FAILED:
    case types.GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          results: [],
        },
      };
    case types.GET_LIST_SUCCEED:
      return {
        ...state,
        list: {
          ...state.list,
          results: transformIdOfList(payload.content, 'uuid'),
          totalPages: payload.totalPages,
          totalElements: payload.totalElements,
        },
      };
    case types.GET_FILTERS_FAILED:
    case types.GET_FILTERS:
      return {
        ...state,
        list: {
          ...state.list,
          filters: initialState.list.filters,
        },
      };
    case types.GET_FILTERS_SUCCEED:
      return {
        ...state,
        list: {
          ...state.list,
          filters: payload,
        },
      };
    case types.CLOSE_RESPONSE_DIALOG:
      return {
        ...state,
        responseDialog: {
          ...state.responseDialog,
          open: false,
        },
      };
    case types.SAVE_CONTRACT:
      return {
        ...state,
        saveContract: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: false,
          success: false,
          errorCode: '',
        },
      };
    case types.SAVE_CONTRACT_SUCCEED:
      return {
        ...state,
        saveContract: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: true,
          errorCode: '',
        },
      };
    case types.SAVE_CONTRACT_FAILED:
      return {
        ...state,
        saveContract: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: false,
          errorCode: payload.code,
          message: payload.message,
        },
      };
    case types.GET_CONTRACT_DETAILS:
    case types.CLEAN_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetails: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialog: initialState.responseDialog,
      };
    case types.GET_CONTRACT_DETAILS_SUCCEED:
      return {
        ...state,
        contractDetails: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
      };
    case types.GET_CONTRACT_DETAILS_FAILED:
      return {
        ...state,
        contractDetails: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
      };
    case types.GET_CONTRACT_VEHICLES:
      return {
        ...state,
        contractDetails: {
          ...state.contractDetails,
          data: {
            ...state.contractDetails.data,
            vehicles: [],
          },
        },
        contractVehicles: {
          ...state.contractVehicles,
          results: {
            page: state.contractVehicles.params.page,
            list: [],
            loading: true,
            success: false,
            error: false,
          },
        },
      };
    case types.GET_CONTRACT_VEHICLES_SUCCEED:
      const { content } = payload;

      const transformedContent = content.map((item) => ({
        ...item,
        createdDateFormatted: moment(item.createdDate, ISO_DATE_FORMAT).format(
          MX_DATE_FORMAT
        ),
      }));

      return {
        ...state,
        contractDetails: {
          ...state.contractDetails,
          data: {
            ...state.contractDetails.data,
            // vehicles: payload.content,
            vehicles: transformedContent,
          },
        },
        contractVehicles: {
          ...state.contractVehicles,
          results: {
            page: payload.first ? 0 : state.contractVehicles.params.page,
            // list: payload.content,
            list: transformedContent,
            loading: false,
            success: true,
            error: false,
          },
          totalPages: payload.totalPages,
          totalElements: payload.totalElements,
        },
      };
    case types.GET_CONTRACT_VEHICLES_FAILED:
      return {
        ...state,
        contractDetails: {
          ...state.contractDetails,
          data: {
            ...state.contractDetails.data,
            vehicles: [],
          },
        },
        contractVehicles: {
          ...state.contractVehicles,
          results: {
            list: [],
            loading: false,
            success: false,
            error: true,
          },
        },
      };
    case types.SET_PAGE_CONTRACT_VEHICLES:
      return {
        ...state,
        contractVehicles: {
          ...state.contractVehicles,
          params: {
            ...state.contractVehicles.params,
            page: payload,
          },
        },
      };
    case types.CHANGE_OF_VEHICLE:
      return {
        ...state,
        changeOfVehicle: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: false,
          success: false,
          errorCode: '',
        },
      };
    case types.CHANGE_OF_VEHICLE_SUCCEED:
      return {
        ...state,
        changeOfVehicle: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: true,
          errorCode: '',
        },
      };
    case types.CHANGE_OF_VEHICLE_FAILED:
      return {
        ...state,
        changeOfVehicle: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: false,
          errorCode: payload.code,
          message: payload.message,
        },
      };
    case types.CREATE_LOAN:
      return {
        ...state,
        createLoan: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: false,
          success: false,
          errorCode: '',
        },
      };
    case types.CREATE_LOAN_SUCCEED:
      return {
        ...state,
        createLoan: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: true,
          errorCode: '',
        },
      };
    case types.CREATE_LOAN_FAILED:
      return {
        ...state,
        createLoan: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: false,
          errorCode: payload.code,
          message: payload.message,
        },
      };
    case types.EDIT_CATEGORY_SUBCATEGORY:
      return {
        ...state,
        editCategorySubcategory: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: false,
          success: false,
          errorCode: '',
        },
      };
    case types.EDIT_CATEGORY_SUBCATEGORY_SUCCEED:
      return {
        ...state,
        editCategorySubcategory: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: true,
          errorCode: '',
        },
      };
    case types.EDIT_CATEGORY_SUBCATEGORY_FAILED:
      return {
        ...state,
        editCategorySubcategory: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
        responseDialog: {
          ...state.responseDialog,
          open: true,
          success: false,
          errorCode: payload.code,
          message: payload.message,
        },
      };
    case types.RESET:
      return initialState;
    case types.UPLOAD_CONTRACT:
      return {
        ...state,
        saveContract: {
          success: false,
          error: false,
          errorMessage: '',
          data: {},
        },
        responseDialogUpdateContract: {
          open: false,
          success: false,
          errorCode: '',
          errorMessage: '',
          modalType: '',
        },
      };
    case types.UPDATE_CONTRACT_SUCCEED:
      return {
        ...state,
        saveContract: {
          success: true,
          error: false,
          errorMessage: '',
          data: payload,
        },
        responseDialogUpdateContract: {
          open: true,
          success: true,
          errorCode: '',
          errorMessage: '',
          modalType: '',
        },
      };
    case types.UPDATE_CONTRACT_FAILED:
      return {
        ...state,
        saveContract: {
          success: false,
          error: true,
          errorMessage: payload,
          data: {},
        },
        responseDialogUpdateContract: {
          open: true,
          success: false,
          errorCode: payload.errorCode,
          errorMessage: payload.errorMessage,
          modalType: '',
        },
      };
    case types.CLOSE_RESPONSE_DIALOG_UPDATE_CONTRACT:
      return {
        ...state,
        responseDialogUpdateContract: {
          open: false,
          success: false,
          errorCode: '',
          errorMessage: '',
          modalType: '',
        },
      };
    case types.UPLOAD_VEHICLES_VC:
      return {
        ...state,
        loader: true,
        massiveRecords: {
          ...state.massiveRecords,
          process: payload.process,
        },
        resultMessage: {
          ...state.resultMessage,
          success: true,
          open: false,
        },
      };
    case types.SET_MASSIVE_CHANGE_TYPE:
      return {
        ...state,
        massiveChangeType: payload,
      };
    case types.UPLOAD_MASSIVE_CHANGE:
      const clearRecordsOnChange = !payload.process;

      return {
        ...state,
        loader: true,
        vehiclesMassiveChangeRecords: {
          ...state.vehiclesMassiveChangeRecords,
          process: payload.process,
          success_records: clearRecordsOnChange
            ? []
            : state.vehiclesMassiveChangeRecords.success_records,
          failed_records: clearRecordsOnChange
            ? []
            : state.vehiclesMassiveChangeRecords.failed_records,
        },
        resultMessage: {
          ...state.resultMessage,
          success: true,
          open: false,
        },
      };
    case types.UPLOAD_VEHICLES_VC_SUCCEED:
      return {
        ...state,
        loader: false,
        resultMessage: {
          ...state.resultMessage,
          success: true,
          open: true,
        },
        massiveRecords: {
          ...state.massiveRecords,
          ...payload.data,
        },
      };
    case types.UPLOAD_MASSIVE_CHANGE_SUCCEEDED:
      const clearRecordsOnSuccess =
        state.vehiclesMassiveChangeRecords &&
        state.vehiclesMassiveChangeRecords.process === true;

      return {
        ...state,
        loader: false,
        resultMessage: {
          ...state.resultMessage,
          success: true,
          errorCode: '',
          errorMessage: '',
          open: true,
        },
        vehiclesMassiveChangeRecords: {
          ...state.vehiclesMassiveChangeRecords,
          ...payload.data,
          success_records: clearRecordsOnSuccess
            ? []
            : payload.data.success_records,
          failed_records: clearRecordsOnSuccess
            ? []
            : payload.data.failed_records,
        },
      };
    case types.UPLOAD_VEHICLES_VC_FAILED:
      return {
        ...state,
        loader: false,
        resultMessage: {
          ...state.resultMessage,
          success: false,
          errorCode,
          open: true,
        },
        massiveRecords: {
          ...state.massiveRecords,
          success_records: [],
          failed_records: [],
        },
      };
    case types.UPLOAD_MASSIVE_CHANGE_FAILED:
      return {
        ...state,
        loader: false,
        resultMessage: {
          ...state.resultMessage,
          success: false,
          errorCode: payload.code,
          errorMessage: payload.message,
          open: true,
        },
        vehiclesMassiveChangeRecords: {
          ...state.vehiclesMassiveChangeRecords,
          success_records: [],
          failed_records: [],
        },
      };
    case types.CLOSE_CONFIRMATION_MESSAGE:
      return {
        ...state,
        confirmationMessage: false,
      };
    case types.SHOW_CONFIRMATION_MESSAGE:
      return {
        ...state,
        confirmationMessage: true,
      };
    case types.CLOSE_RESULT_MESSAGE:
      return {
        ...state,
        resultMessage: {
          ...state.resultMessage,
          open: false,
        },
      };
    default:
      return state;
  }
}
